// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6d507de3","455":"d5f88c12","977":"746a7ad2"}[chunkId] + ".chunk.js";
};